<template lang="html">
<div>
  <div class="header-container">
    <v-container class="parallax-container-center">
      <v-layout justify-center align-center class="header-layout">
        <v-flex xs12 sm10 md8 lg6 xl4>
          <h1 class="parallax-middle-header">Building great games</h1>

          <br>
          <p>Blitzoo specializes in developing platforms that enable land-based slot game manufacturers to seamlessly bring their content to desktop and mobile devices. We are committed to delivering highly optimized and stable products, ensuring that players enjoy a smooth and immersive gaming experience that mirrors the excitement of the casino floor.</p>
        </v-flex>
      </v-layout>
    </v-container>
  </div>

  <section id="descriptionBackground">
      <v-layout
        column
        wrap
        class="py-5"
        align-center
        xs10 offset-xs1
      >
        <v-flex xs12>
          <v-container grid-list-xs id="descriptionContainer">
            <v-layout row wrap align-start justify-center>
              <v-flex xs12 md10 class="ieFlex">
                <v-card class="elevation-0 transparent">
                  <img
                    :src="socialCasino"
                    style="border-radius: 1rem; width: 70%;">
                  <v-card-title primary-title class="layout justify-center pb-1">
                    <div class="headline description-section body-title"><span class="games-description-title">Social Casino</span></div>
                  </v-card-title>
                  <v-card-text class='description-section description-body pt-1' id="social-casino-text">
                    Big wins, and bigger fun on<br>
                    your desktop or mobile device!
                  </v-card-text>
                  <!-- <v-btn large color="#f38120" class="body-btn"><span class="header-btn-text">PLAY NOW</span></v-btn> -->
                  <v-btn round color="#fd00b5" class="home-body-btn playNowLink" style="width: 70%" to="/social-games"><span class="home-body-btn-text">LEARN MORE</span></v-btn>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>
</div>
</template>

<script>
export default {
  data () {
    return {
      // lobster: require('../../assets/thumbnails/Thumbnail_Lobstermania.png'),
      // smvThumbnail: require('../../assets/thumbnails/Thumbnail_SMVS.png'),
      landBased: require('../../assets/thumbnails/Thumbnail_LandBased.png'),
      socialCasino: require('../../assets/thumbnails/Thumbnail_SocialCasinos.png'),
      windowWidth: 0,
      windowHeight: 0
    }
  },
  methods: {
    changeSocialHeight (event) {
      if (this.windowWidth >= 1264) {
        document.querySelector('#slot-games-text').style.height = '88px'
      } else if (this.windowWidth >= 960 && this.windowWidth < 1264) {
        document.querySelector('#slot-games-text').style.height = '160px'
      } else if (this.windowWidth >= 714 && this.windowWidth < 960) {
        document.querySelector('#slot-games-text').style.height = '52px'
      } else if (this.windowWidth >= 422 && this.windowWidth < 714) {
        document.querySelector('#slot-games-text').style.height = '88px'
      } else if (this.windowWidth >= 0 && this.windowWidth < 422) {
        document.querySelector('#slot-games-text').style.height = '124px'
      }
    },
    getWindowWidth (event) {
      this.windowWidth = window.innerWidth
    },
    getWindowHeight (event) {
      this.windowHeight = document.documentElement.clientHeight
    }
  },
  mounted () {
    this.$nextTick(function () {
      // window.addEventListener('resize', this.getWindowWidth)
      // window.addEventListener('resize', this.getWindowHeight)
      // window.addEventListener('resize', this.changeSocialHeight)
      //
      // // Init
      // this.getWindowWidth()
      // this.getWindowHeight()
      // this.changeSocialHeight()
    })

    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
      Array.from(document.querySelectorAll('.ieFlex')).forEach(function (el) {
        let docFrag = document.createDocumentFragment()
        while (el.firstChild) {
          let child = el.removeChild(el.firstChild)
          docFrag.appendChild(child)
        }

        // replace el with document fragment
        el.parentNode.replaceChild(docFrag, el)
      })

      this.footerHeight = parseInt(getComputedStyle(document.querySelector('#descriptionContainer')).height) + 30

      this.originalFooter = parseInt(getComputedStyle(document.querySelector('#footer')).height)
      document.querySelector('#footer').style.height = this.footerHeight + 'px'
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
    window.removeEventListener('resize', this.getWindowHeight)
    window.removeEventListener('resize', this.changeSocialHeight)

    document.querySelector('#footer').style.height = this.originalFooter + 'px'
  }
}
</script>

<style lang="scss" scoped>
.header-container {
  background-image: url('../../assets/Header_Games.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.header-layout {
  margin: 2rem 0;
}

.parallax-container-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
}

.parallax-middle-header {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 2.7rem;
  align-self: stretch;
}

#descriptionBackground {
  background-image: url('../../assets/Background_Yellow.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.body-title {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 700;
  font-size: 33px;
  color: #f6821f;
}

.description-body {
  font-family: 'open-sans-semibold', serif;
  font-size: 1.4rem;
  color: #120035;
}

.games-description-title {
  font-family: 'open-sans-bold', serif;
  font-size: 2rem;
  color: #ff9005;
}

.home-body-btn {
  font-family: 'open-sans-extrabold', serif;
  font-size: 1.4rem;
}

.home-body-btn-text {
  color: #ffffff;
}
</style>
